export default __webpack_public_path__ + "static/media/add-document.3f51c4fe.svg";